var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatDiaryViewCycleEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9f92;}.cls-2{fill:#ff4a4a;}.cls-3{fill:#ccc;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heat_cycle_new_entry"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.41,60.51c-36.65,0-66.35,26.72-66.35,59.68V538c0,33,29.7,59.68,66.35,59.68H532.9c36.66,0,66.35-26.71,66.35-59.68V120.19c0-33-29.69-59.68-66.35-59.68H68.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.41,60.51c-36.65,0-66.35,26.85-66.35,59.68v89.52H599.25V120.19c0-32.83-29.69-59.68-66.35-59.68H68.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.53.83A29.84,29.84,0,0,0,79.69,30.67v89.52a29.84,29.84,0,1,0,59.68,0V30.67A29.84,29.84,0,0,0,109.53.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M483.57.83c-16.47,0-29.84,11.93-29.84,29.84v89.52c0,14.92,13.37,29.84,29.84,29.84s29.84-14.92,29.84-29.84V30.67C513.41,12.76,500,.83,483.57.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.77,284.87v59.78a27.82,27.82,0,0,0,27.82,27.82h59.78a27.82,27.82,0,0,0,27.81-27.82V284.87a27.81,27.81,0,0,0-27.81-27.81H96.59A27.81,27.81,0,0,0,68.77,284.87Zm173.12,0v59.78a27.82,27.82,0,0,0,27.81,27.82h59.78a27.82,27.82,0,0,0,27.82-27.82V284.87a27.81,27.81,0,0,0-27.82-27.81H269.7A27.81,27.81,0,0,0,241.89,284.87Zm173.12,0v59.78a27.82,27.82,0,0,0,27.81,27.82H502.6a27.83,27.83,0,0,0,27.82-27.82V284.87a27.82,27.82,0,0,0-27.82-27.81H442.82A27.81,27.81,0,0,0,415,284.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.77,458v59.78a27.81,27.81,0,0,0,27.82,27.81h59.78a27.81,27.81,0,0,0,27.81-27.81V458a27.82,27.82,0,0,0-27.81-27.82H96.59A27.82,27.82,0,0,0,68.77,458Zm173.12,0v59.78a27.81,27.81,0,0,0,27.81,27.81h59.78a27.81,27.81,0,0,0,27.82-27.81V458a27.82,27.82,0,0,0-27.82-27.82H269.7A27.82,27.82,0,0,0,241.89,458ZM415,458v59.78a27.81,27.81,0,0,0,27.81,27.81H502.6a27.82,27.82,0,0,0,27.82-27.81V458a27.83,27.83,0,0,0-27.82-27.82H442.82A27.82,27.82,0,0,0,415,458Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDiaryViewCycleEntries);
export default __webpack_public_path__ + "static/media/heat_diary_view_cycle_entries.10d9a97f49ddb16949a2ab1fe36ae3ba.svg";
export { ForwardRef as ReactComponent };